import { useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import { MtaCancellationReason } from '../../services/api';
import { MidTermAdjustmentClient as MidTermAdjustmentClientV2 } from '../../services/mtaApiV2';
import API from '../../services/AxiosInstance';
import { clearMidTermAdjustmentDetails } from '../../store/midTermAdjustment.slice';
import { resetApiMTA } from '../../store/midTermAdjustmentAPI.sclice';
import { clearMidTermAdjustmentResponseDetails } from '../../store/midTermAdjustmentRatingResponse.slice';
import { ROUTE_PATHS } from '../../utils/Routes';
import { useAppDispatch, useAppSelector } from '../reduxHook';

export const useDiscardMta = () => {
	const dispatch = useAppDispatch();
	const midTermAdjustment = useAppSelector((redux) => redux.midTermAdjustment);
	const fullPolicy = useAppSelector((redux) => redux.fullPolicy);
	const navigate = useNavigate();
	const [discardLoading, setDiscardLoading] = useState(false);
	const isDiscardingRef = useRef(false);

	const handleDiscardMta = async (routeLocation?: string) => {
		// Prevent multiple simultaneous calls
		if (isDiscardingRef.current) {
			return;
		}

		const targetRoute = routeLocation || ROUTE_PATHS.home;
		try {
			isDiscardingRef.current = true;
			setDiscardLoading(true);

			const client = new MidTermAdjustmentClientV2(undefined, API);
			await client.cancelMidTermAdjustment(
				fullPolicy.policyToken || midTermAdjustment.policyToken,
				midTermAdjustment.transactionId,
				MtaCancellationReason.CLIENTDECISION,
			);

			// Clear state after successful cancellation
			dispatch(clearMidTermAdjustmentDetails());
			dispatch(resetApiMTA());
			dispatch(clearMidTermAdjustmentResponseDetails());

			navigate(targetRoute);
		} catch (error) {
			console.error('Unable to discard MTA', error);

			// Clear state even on error
			dispatch(resetApiMTA());
			dispatch(clearMidTermAdjustmentDetails());

			// Ensure navigation on error
			navigate(targetRoute);
		} finally {
			setDiscardLoading(false);
			isDiscardingRef.current = false;
		}
	};

	return {
		discardLoading,
		handleDiscardMta,
	};
};
